export const featuredData = [
  {
    url: "h",
    gitUrl: "https://github.com/Vedantadlak/GEEK-CART",
    liveUrl: "https://aesthetic-genie-e68104.netlify.app/",
    mainHeader: "GEEK CART",
    mainContent: `A shopping cart web application made using React and styled through Chakra UI.`,
    probDescription: ``,
    featDescription: `Build using React and styled through Chakra UI | Authentication done using Firebase Authentication | Seller/Admin Login done using Firebase Admin SDK with Node.js, Express.js Backend |Implemented Seller/Admin ”Add Product” functionality and used Firebase- Firestore Database for storing data | 
 Deployed live using Netlify`,
  },
  {
    url: "h",
    gitUrl: "https://github.com/Ameen-Here/slack-website-clone",
    liveUrl: "h",
    mainHeader: "Food Villa",
    mainContent: `A Food ordering web application made using React and styled through Tailwind CSS .`,
    probDescription: ``,
    featDescription: ` Built using React, tailwindCSS  |  Builded React App from scratch using tools like Babel and Parcel | The Fetch API was used to make asynchronous HTTP requests and retrieve data from external APIs, here Swiggy API | React Router was used for implementing client-side routing, allowing seamless navigation between different pages and components.
| Lazy Loading was implemented to optimize the initial loading time and improve overall performance `,
  },

  {
    url: "h",

    gitUrl: "https://github.com/Vedantadlak/Portfolio-Website",
    mainHeader: "Personal Portfolio",
    mainContent:
      "My personal portfolio website to showcase my projects and skillset. Created using HTML, CSS, ReactJS, Chakra UI, etc. All my contact details are provided on this website, feel free to reach out.",
    featDescription: `Responsive across devices | Dark theme `,
  },
];
